// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_WorkOrdersResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/work_orders/{order_id}.
 */
import type { Orders_WorkOrderRow } from './Orders_WorkOrderRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_WorkOrdersResponseDados = Orders_WorkOrderRow[];

export type Orders_WorkOrdersResponse = ApiResponse<Orders_WorkOrdersResponseDados>;

registerResponseContract('Orders_WorkOrdersResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_work_order_id:               { type: 'number',  required: true },
      so_work_order_order_item_id:    { type: 'number',  required: true },
      so_work_order_status:           { type: 'string',  required: true },
      so_work_order_deadline_at:      { type: 'string',  required: false },
      so_work_order_started_at:       { type: 'string',  required: false },
      so_work_order_completed_at:     { type: 'string',  required: false },
      so_work_order_assignee_user_id: { type: 'string',  required: false },
      so_work_order_notes:            { type: 'string',  required: false },
      so_work_order_created_at:       { type: 'string',  required: true },
      so_order_item_description:      { type: 'string',  required: false },
      so_order_item_type:             { type: 'string',  required: true },
      so_order_item_quantity:         { type: 'number',  required: true },
      so_order_item_unit_price:       { type: 'number',  required: true },
      so_order_item_order_id:         { type: 'number',  required: true },
    },
  },
})
